<template>
  <div>
    <div class="row b-form__container_type_flex b-form__row_type_flex-end">
      <div class="col-4">
        <label>{{$t('CONTENT.indexation.indexation_kind')}}:<span class="b-form__required"> *</span></label>
        <cool-select :list="availableIndexations"
                     option-value="id"
                     option-text="name"
                     :placeholder="$t('CONTENT.choose')"
                     v-model="indexationKindId"></cool-select>
      </div>
      <div class="col-3">
        <label>{{$t('CONTENT.indexation.firstIndexationDate')}}:</label>
        <datepicker class="b-datepicker" v-model="firstIndexationDate" :disabled="isDisabledIndexationDate"
                    :formatter="datepickerFormat" :disabled-date="disabledDate"/>
      </div>
      <div class="col-3">
        <label>{{$t('CONTENT.percent')}}:</label>
        <numeric class="b-numeric" controls :min="0" :max="100" :disabled="isDisabledIndexationPercent"
                 v-model="indexationPercent"></numeric>
      </div>
    </div>
    <div class="row mt-5 b-form__container_type_flex b-form__row_type_flex-end">
      <div class="col-7">
        <label for="comment">{{$t('CONTENT.comment')}}:</label>
        <input type="text" id="comment" class="b-textarea" v-model="newIndexation.commentary"
               :disabled="isDisabledIndexationComment">
      </div>
    </div>
  </div>
</template>

<script>
import dateConverter from "@/utils/converters/date.converter";
import { mapGetters } from 'vuex';
import SetIndexation from "../../models/commands/SetIndexation";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      isDisabledIndexationDate: false,
      isDisabledIndexationPercent: false,
      isDisabledIndexationComment: false,
      currentIndexationName: null,
      newIndexation: {
        indexationKindId: null,
        firstIndexationDate: null,
        indexationPercent: null,
        commentary: null
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["getPaymentNames"]),
    allIndexations() {
      return this.$store.getters['indexationPlugin/getAllIndexations'];
    },
    availableIndexations() {
      if(this.paymentParams.paymentNameId !== null) {
        let availableIndexations = [];

        for (let i = 0; i < this.getPaymentNames.length; i++) {
          let currentPaymentNameTypeCode = this.getPaymentNames[i].paymentTypeCode;
          let currentPaymentNameKindCode = this.getPaymentNames[i].paymentKindCode;

          let isPaymentWithoutIndexation = currentPaymentNameTypeCode === 'penalty_payment' ||
            currentPaymentNameTypeCode === 'residual_value_guarantees' ||
            currentPaymentNameTypeCode === 'purchase_option' ||
            currentPaymentNameTypeCode === 'variable_lease_payment_not_depend_on_index' ||
            (currentPaymentNameTypeCode === 'fixed_lease_payment' && currentPaymentNameKindCode === "upfront_payment");

          if(this.getPaymentNames[i].idInDB === this.paymentParams.paymentNameId) {
            if(isPaymentWithoutIndexation) {
              return availableIndexations = this.allIndexations.filter(elem => elem.typeNumber === 4);
            }
          } else {
            return availableIndexations = this.allIndexations;
          }
        }
      }
    },
    indexationKindId: {
      get() {
        return this.newIndexation.indexationKindId;
      },
      set(newVal) {
        this.newIndexation.indexationKindId = newVal;

        this.setIndexationInfo(newVal);
      }
    },
    indexationPercent: {
      get() {
        if (this.newIndexation.indexationPercent !== null) {
          return this.newIndexation.indexationPercent;
        }
      },
      set(newVal) {
        this.newIndexation.indexationPercent = newVal;
      }
    },
    firstIndexationDate: {
      get() {
        if (this.newIndexation.firstIndexationDate === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.newIndexation.firstIndexationDate);
        }
      },
      set(newVal) {
        if(newVal !== null) {
          this.newIndexation.firstIndexationDate = dateConverter.convertToString(newVal);
        } else {
          this.newIndexation.firstIndexationDate = null;
        }
      }
    },
  },
  methods: {
    init() {
      if (this.paymentParams.indexation.indexationKindId !== null) {
        this.newIndexation = {
          indexationKindId: this.paymentParams.indexation.indexationKindId,
          firstIndexationDate: this.paymentParams.indexation.firstIndexationDate,
          indexationPercent: this.paymentParams.indexation.indexationPercent,
          commentary: this.paymentParams.indexation.commentary
        };
        this.setIndexationInfo(this.newIndexation.indexationKindId);
      } else {
        this.newIndexation = {};
      }
    },

    setIndexationInfo(indexationId) {
      let chosenIndexation = {};
      for (let i = 0; i < this.allIndexations.length; i++) {
        if(this.allIndexations[i].id === indexationId) {
          chosenIndexation = this.allIndexations[i];
          this.currentIndexationName = chosenIndexation.name;
        }
      }

      if(chosenIndexation.typeNumber === 4) {
        this.newIndexation.firstIndexationDate = null;
        this.newIndexation.indexationPercent = null;
        this.isDisabledIndexationDate = true;
        this.isDisabledIndexationPercent = true;
      } else if(chosenIndexation.typeNumber === 3) {
        this.isDisabledIndexationDate = false;
        this.isDisabledIndexationPercent = false;
        this.newIndexation.indexationPercent = 0;
      } else {
        this.isDisabledIndexationDate = false;
        this.isDisabledIndexationPercent = false;
        if (this.newIndexation.indexationPercent === 0) {
          this.newIndexation.indexationPercent = null;
        }
      }
    },

    cancel() {
      this.init();
    },

    save() {
      let firstIndexationDateAsDate = null;
      let firstIndexationDateAsDay = null;
      let firstIndexationDateAsMonth = null;
      let firstIndexationDateAsYear = null;

      if(this.newIndexation.firstIndexationDate !== null) {
        firstIndexationDateAsDate = dateConverter.convertToDate(this.newIndexation.firstIndexationDate);
        firstIndexationDateAsDay = this.$moment(firstIndexationDateAsDate).format('DD');
        firstIndexationDateAsMonth = this.$moment(firstIndexationDateAsDate).format('MM');
        firstIndexationDateAsYear = this.$moment(firstIndexationDateAsDate).format('YYYY');
      }

      const transformedIndexationForCommand = {
        indexationKindId: this.newIndexation.indexationKindId,
        indexationPercent: this.newIndexation.indexationPercent,
        commentary: this.newIndexation.commentary,
        firstIndexationDateDay: firstIndexationDateAsDay,
        firstIndexationDateMonth: firstIndexationDateAsMonth,
        firstIndexationDateYear: firstIndexationDateAsYear,
      };

      const command = new SetIndexation(
        this.paymentParams.idInDB,
        transformedIndexationForCommand,
        this.currentIndexationName
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    },

    disabledDate(date) {
      const startDate = this.paymentParams.startDate
      if(startDate === null || startDate === '') return false
      return date < dateConverter.convertToDate(startDate)
    }
  }
};
</script>

<style>
</style>
